import { css } from "styled-components";
import { boldTypographyMixin, textUppercaseMixin } from "../../shared/mixins/typography";
import { mediaQueries } from "../../shared/mixins/breakpoints";
export const headingTextFontMixin = css `
  ${textUppercaseMixin}
  font-family: Maleo, sans-serif;
  text-wrap: balance;
  font-weight: 700;
  word-break: break-word;

  &:lang(ja-jp) {
    font-family: "Beaufort for LOL Ja", sans-serif;
    font-weight: 900;
  }

  &:lang(vi-vn) {
    font-family: Inter, sans-serif;
  }
`;
export const bodyTextFontMixin = css `
  font-family: Beatrice, sans-serif;
  font-weight: 400;
  text-wrap: wrap;
  word-break: break-word;

  &:lang(ja-jp) {
    font-family: SpiegelJa, sans-serif;
  }

  &:lang(vi-vn) {
    font-family: Inter, sans-serif;
  }
`;
export const body1TypographyMixin = css `
  ${bodyTextFontMixin}
  font-size: 28px;
  line-height: 40px;
  ${mediaQueries.tabletDown} {
    font-size: 22px;
    line-height: 36px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 18px;
    line-height: 28px;
  }
`;
export const body2TypographyMixin = css `
  ${bodyTextFontMixin}
  font-size: 22px;
  line-height: 36px;
  ${mediaQueries.tabletDown} {
    font-size: 18px;
    line-height: 28px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 16px;
    line-height: 26px;
  }
`;
export const body3TypographyMixin = css `
  ${bodyTextFontMixin}
  font-size: 18px;
  line-height: 28px;
  ${mediaQueries.tabletDown} {
    font-size: 16px;
    line-height: 26px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 14px;
    line-height: 22px;
  }
`;
export const body4TypographyMixin = css `
  ${bodyTextFontMixin}
  font-size: 16px;
  line-height: 26px;

  ${mediaQueries.tabletDown} {
    font-size: 14px;
    line-height: 22px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 12px;
    line-height: 18px;
  }
`;
export const body5TypographyMixin = css `
  ${bodyTextFontMixin}
  font-size: 14px;
  line-height: 22px;

  ${mediaQueries.tabletDown} {
    font-size: 12px;
    line-height: 18px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 10px;
    line-height: 16px;
  }
`;
export const display1TypographyMixin = css `
  ${headingTextFontMixin}
  font-weight: 900;
  font-size: 160px;
  line-height: 150px;
  ${mediaQueries.tabletDown} {
    font-size: 115px;
    line-height: 115px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 64px;
    line-height: 65px;
  }
`;
export const display2TypographyMixin = css `
  ${headingTextFontMixin}
  font-weight: 900;
  font-size: 100px;
  line-height: 100px;
  ${mediaQueries.tabletDown} {
    font-size: 64px;
    line-height: 65px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 48px;
    line-height: 50px;
  }
`;
export const display3TypographyMixin = css `
  ${headingTextFontMixin}
  font-weight: 700;
  font-size: 80px;
  line-height: 80px;
  ${mediaQueries.tabletDown} {
    font-size: 48px;
    line-height: 50px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 32px;
    line-height: 35px;
  }
`;
export const display4TypographyMixin = css `
  ${headingTextFontMixin}
  font-weight: 700;
  font-size: 64px;
  line-height: 65px;
  ${mediaQueries.tabletDown} {
    font-size: 32px;
    line-height: 35px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 28px;
    line-height: 30px;
  }
`;
export const display5TypographyMixin = css `
  ${headingTextFontMixin}
  font-weight: 700;
  font-size: 48px;
  line-height: 50px;
  ${mediaQueries.tabletDown} {
    font-size: 28px;
    line-height: 30px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 26px;
    line-height: 28px;
  }
`;
export const display6TypographyMixin = css `
  ${headingTextFontMixin}
  font-weight: 700;
  font-size: 32px;
  line-height: 35px;
  ${mediaQueries.tabletDown} {
    font-size: 24px;
    line-height: 25px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 24px;
    line-height: 25px;
  }
`;
export const display7TypographyMixin = css `
  ${headingTextFontMixin}
  font-weight: 700;
  font-size: 24px;
  line-height: 25px;
  ${mediaQueries.tabletDown} {
    font-size: 20px;
    line-height: 22px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 18px;
    line-height: 20px;
  }
`;
export const display8TypographyMixin = css `
  ${headingTextFontMixin}
  font-weight: 700;
  font-size: 20px;
  line-height: 22px;
  ${mediaQueries.tabletDown} {
    font-size: 16px;
    line-height: 18px;
  }
`;
export const display9TypographyMixin = css `
  ${headingTextFontMixin}
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  ${mediaQueries.tabletDown} {
    font-size: 16px;
    line-height: 18px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 14px;
    line-height: 16px;
  }
`;
export const eyebrowTypographyMixin = css `
  ${textUppercaseMixin}
  ${bodyTextFontMixin}
  font-weight: normal;
  font-size: 14px;
  ${mediaQueries.mobileDown} {
    font-size: 12px;
  }
`;
export const tagTypographyMixin = css `
  ${textUppercaseMixin}
  ${bodyTextFontMixin}
  font-weight: 500;
  font-size: 14px;
`;
export const labelTypographyMixin = css `
  ${body4TypographyMixin}
`;
export const textLinkTypographyMixin = css `
  ${boldTypographyMixin}
  ${bodyTextFontMixin}
  font-size: 16px;
`;
export const ctaTypographyMixin = css `
  ${headingTextFontMixin}
  ${textUppercaseMixin}
  font-size: 22px;
  text-align: center;
  ${mediaQueries.mobileDown} {
    font-size: 20px;
  }
`;
//# sourceMappingURL=typography.js.map